import React, { useEffect, useState } from 'react';
import { setMessage } from 'redux/actions';
import Store from 'redux/Store';
import getPages from 'utils/getPages'
import { NavLink } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Menu from 'shared/components/Menu'
import Navbar from 'shared/components/Navbar'
import hasAnyRole from 'shared/utils/hasAnyRole';

interface HeaderProps {
    title: string
    addLink?: string|undefined,
    addLinkRoles?: String[],
    message: any
    headerInsert?: React.FunctionComponent | React.ReactElement | false
}

const Header: React.FunctionComponent<HeaderProps> = (props) => {
    
    const [pages, setPages] = useState<any>([])
    const [hasTopMenu, setHasTopMenu] = useState<boolean>(false)

    useEffect(() => {
        const pages = getPages('top')
        setPages(pages)
        setHasTopMenu(!!pages.length)
    }, [])
    
    useEffect(() => {
        if(props.message.text.length > 0){
            toast(props.message.text, {
                'type': props.message.status,
            })
        }
        window.scrollTo(0, 0)
        Store.dispatch(setMessage('', '', 'onNavigate'))
    }, [window.location.pathname])
    
    useEffect(() => {
        if ((props.message.text.length > 0) && (props.message.display === 'instant')){
            toast(props.message.text, {
                'type': props.message.status,
                'autoClose': 10000 
            })
            window.scrollTo(0, 0)
            Store.dispatch(setMessage('', '', 'onNavigate'))
        }
    }, [props.message])
    
    let addButton: React.ReactElement|string = '';
    if ((typeof props.addLink !== 'undefined') && props.addLink && (props.addLinkRoles === undefined || hasAnyRole(props.addLinkRoles))){
        addButton = <div className="add-cont">
            <NavLink to={props.addLink}>
                <i className="bi-plus-circle-fill create-icon"></i> &nbsp; Create New
            </NavLink>
        </div>
    }

    return (
        <div className={hasTopMenu ? 'header has-top-menu' : 'header'}>
            {hasTopMenu && <Menu position="top" /> }
            <div className="row">
                <div className="col-12 text-white p-t-40 p-b-90">
                    <h3 className="d-none d-lg-block">{props.title}</h3>
                    <div className="header-menu">
                        
                    </div>
                    <Navbar title={props.title} />
                    {addButton}
                </div>
            </div>
            {(typeof props.headerInsert != 'undefined') && props.headerInsert && <div className="insert-cont">
                {props.headerInsert}
            </div>}
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default Header;